export type PerformanceMetric = {
  name: 'repository-query' | 'navigation';
  durationMs: number;
  area: string;
};

/** Removes IDs, search terms, and other user-controlled suffixes from keys. */
export function metricArea(key: string): string {
  const candidate = key.split(':', 1)[0]?.toLowerCase() ?? 'unknown';
  return /^[a-z][a-z-]{0,39}$/.test(candidate) ? candidate : 'unknown';
}

export function reportPerformance(metric: PerformanceMetric): void {
  window.dispatchEvent(
    new CustomEvent<PerformanceMetric>('growhub:performance', {
      detail: metric,
    }),
  );
}

export async function measureRepositoryQuery<T>(
  key: string,
  load: () => Promise<T>,
): Promise<T> {
  const started = performance.now();
  try {
    return await load();
  } finally {
    reportPerformance({
      name: 'repository-query',
      area: metricArea(key),
      durationMs: performance.now() - started,
    });
  }
}

/** Starts privacy-safe navigation timing; no account or record IDs are emitted. */
export function startPerformanceTelemetry(): void {
  window.addEventListener('load', () => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation) {
      reportPerformance({
        name: 'navigation',
        area: 'app',
        durationMs: navigation.duration,
      });
    }
  }, { once: true });
}
